export default __webpack_public_path__ + "static/9-501d305ca7fbaecaf4ba576c54e9102a.png";